import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="Expoziția absolvenților UAD este unul din evenimentele de tradiție ale Universității de Artă și Design din Cluj-Napoca, ajuns la cea de a XX-a ediție, și reprezintă cea mai așteptată expoziție anuală din mediul artistic universitar național." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
